import * as React from "react";
import Box from '@mui/material/Box';
import { Card, Grid } from "@mui/material";
import PartialTrip from '../../pages/PartialTrip/PartialTrip';
import TripRoutes from '../../pages/TripRoutes/TripRoutes';
import { useEffect,useState } from "react";
import Agenda from "../../common/Agenda/Agenda";



const TripsAgenda = () => {
  const [PartialTripTripNumber, setTripNumber] = useState(null);

  useEffect(() => {
    setTripNumber(JSON.parse(
      localStorage.getItem('PartialTripTripNumber')
    ))
  }, [])

  return (
    <>

      <Box component="main" sx={{ flexGrow: 1, p: 0 }} className="max-wgrid" >
        <Grid container columnSpacing={{ xs: 0, sm: 0 }} sx={{ marginTop: 0 }}  >
          <Grid item xs={6} component={Card} elevation={0} square pl={0}  >
            <PartialTrip Header={'Partial trip'} routeName={'/partialtrip'} isDisablePopup="true" />
          </Grid>
          <Grid item xs={6} component={Card} elevation={0} square pl={0}  >
            <TripRoutes Header={'Route'} routeName={'/route'} isDisablePopup="true" size='12'/>
          </Grid>


          <Agenda Header={'Trip Agenda'} routeName={'/trip-agenda'} isCrossIcon={false} height='200 ' />


        </Grid>
      </Box>
    </>
  )
};

export default TripsAgenda;
